/** A workspace storage key: the transitional image target of a pre-migration style. */
export function isWorkspaceStorageKey(
  src: string,
  workspaceId: number | undefined,
): boolean {
  return workspaceId !== undefined && src.startsWith(`${workspaceId}/`);
}

// One image per line is how the backend renders a pre-migration style, so a
// line-level match is enough here; the editor uses the full markdown parser.
const IMAGE_LINE_PATTERN = /!\[([^\]]*)\]\((?:<([^>]+)>|([^)\s]+))\)/g;

/**
 * The storage-key images a style document still cites directly, in document
 * order and deduplicated. Empty once the migration has rewritten them as
 * `entity:` citations, which arrive through `cites` instead.
 */
export function parseStorageKeyImageLines(
  markdown: string,
  workspaceId: number | undefined,
): Array<{ storageKey: string; alt: string }> {
  if (workspaceId === undefined) return [];
  const seen = new Set<string>();
  const images: Array<{ storageKey: string; alt: string }> = [];
  for (const match of markdown.matchAll(IMAGE_LINE_PATTERN)) {
    const [, alt, bracketed, bare] = match;
    const target = bracketed ?? bare;
    if (
      target === undefined ||
      !isWorkspaceStorageKey(target, workspaceId) ||
      seen.has(target)
    ) {
      continue;
    }
    seen.add(target);
    images.push({ storageKey: target, alt: alt ?? "" });
  }
  return images;
}
